export default __webpack_public_path__ + "static/media/gold_arrow.d8259ed1.svg";